import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import useFetcher from "../../../../../hooks/useFetcher";
import { fetchTareasByClientes } from "../../../../../services/reportingServices";
import { BlurSpinner } from "../../../../../components/BlurSpinner";
//
const columns = [
  {
    name: "Razón social",
    selector: (row) => row.razonSocial,
    id: "razonSocial",
    sortable: true,
    width: "180px",
    minWidth: "180px",
  },
  {
    name: "Venc. Depto.",
    selector: (row) => row.vencido,
    id: "vencido_departamento",
    sortable: true,
    center: true,
    width: "120px",
    minWidth: "120px",
  },
  {
    name: "Venc. Gral.",
    selector: (row) => row.vencidoTotal,
    id: "vencido_general",
    sortable: true,
    center: true,
    width: "120px",
    minWidth: "120px",
  },
  {
    name: "Pendientes",
    selector: (row) => row.pendiente,
    id: "pendientes",
    sortable: true,
    center: true,
    width: "120px",
    minWidth: "120px",
  },
  {
    name: "Total",
    selector: (row) => row.resuelto + row.pendiente + row.vencidoTotal,
    id: "total",
    sortable: false,
    center: true,
    width: "80px",
    minWidth: "80px",
  },
];

const Table = ({ filters }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [sort, setSort] = useState({ sortBy: "vencido", sortDirection: "desc" });

  // eslint-disable-next-line no-unused-vars
  const [data, isLoading, error, setData, fetchData] = useFetcher(fetchTareasByClientes, [
    { ...filters, page: currentPage, perpage: itemsPerPage, orderBy: sort.sortBy, orderType: sort.sortDirection },
  ]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      fetchData();
    }, 60 * 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [fetchData]);

  return (
    <>
      <div
        style={{
          height: 38 * itemsPerPage + 127,
          width: "100%",
          backgroundColor: "#f7f3f3",
          padding: "15px",
          borderRadius: "20px",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <BlurSpinner isLoading={(!data, isLoading)}>
          <DataTable
            className="custom-table"
            paginationComponentOptions={{ rowsPerPageText: "Clientes por página", rangeSeparatorText: "de", selectAllRowsItemText: "Todos" }}
            noDataComponent={
              <div className="p-3">
                <b>No se encontraron clientes</b>
              </div>
            }
            striped
            pagination
            sortServer
            paginationServer
            data={data.rows}
            paginationTotalRows={data.count}
            paginationDefaultPage={1}
            onChangeRowsPerPage={setItemsPerPage}
            paginationPerPage={itemsPerPage}
            onSort={(a, b) => setSort({ sortBy: a.id, sortDirection: b })}
            onChangePage={setCurrentPage}
            columns={columns}
          />
        </BlurSpinner>
      </div>
    </>
  );
};

export default Table;
